import { ThemeConfigurationType } from '@monorepo/client-types';
import { theme } from 'antd';
import {
  clientPanelLightTheme,
  commonComponentTheme,
  commonCssVars,
  commonLightCssEnv,
  commonTtpCssVars,
} from './common.theme-settings';
import { getThemeFixedColors } from './theme-config.util';

const token = {
  colorPrimary: '#6710FF',
  colorSuccess: '#179DA6',
  colorWarning: '#E9C10F',
  colorError: '#EB0065',
  colorInfo: '#256BE4',
  colorLink: '#3240C2',
  colorBgBase: '#fff',
  colorTextSecondary: '#000000',
  colorBgLayout: '#fafafa',
};

const extraToken = {
  colorBrand: '#6710FF',
  colorAttention: '#FF4D9E',
  colorActive: '#EB0064',
  colorErrorLight: 'rgb(255, 208, 228)',
  colorSecondary: '#FF4D9E',
};

export const fixedTtpToken = getThemeFixedColors({
  ...token,
  ...extraToken,
});

export const LightThemeConfigTtp: ThemeConfigurationType = {
  algorithm: theme.defaultAlgorithm,
  token,
  components: commonComponentTheme,
  cssVars: {
    ...commonCssVars,
    ...commonLightCssEnv,
    ...commonTtpCssVars,
    ...token,
    ...extraToken,
    ...fixedTtpToken,
    ...clientPanelLightTheme,
    'color-text-button-primary': '#000000',
  },
};
